import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function SentEmail2(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "SentEmail2", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.52941 11H32.4706c.936 0 1.8338.3687 2.4957 1.0251C35.6282 12.6815 36 13.5717 36 14.5V32H6V14.5c0-.9283.37185-1.8185 1.03374-2.4749C7.69563 11.3687 8.59335 11 9.52941 11Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M4 32h35v2c0 1.0609-.3688 2.0783-1.0251 2.8284C37.3185 37.5786 36.4283 38 35.5 38h-28c-.92826 0-1.8185-.4214-2.47487-1.1716C4.36875 36.0783 4 35.0609 4 34v-2Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.125 36h-5.25c-.2321 0-.4546-.1054-.6187-.2929C18.0922 35.5196 18 35.2652 18 35c0-.2652.0922-.5196.2563-.7071.1641-.1875.3866-.2929.6187-.2929h5.25c.2321 0 .4546.1054.6187.2929.1641.1875.2563.4419.2563.7071 0 .2652-.0922.5196-.2563.7071-.1641.1875-.3866.2929-.6187.2929Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m44 17.6774-1.3654 6.6891c-.0115.6949-.2973 1.3582-.7969 1.8497-.4996.4914-1.174.7725-1.8804.7838H27.7219c-.7128-.0044-1.3959-.2819-1.9041-.7736-.5082-.4917-.8016-1.1589-.8178-1.8599l1.3654-6.6891c-.0043-.3755.0731-.7476.2271-1.0913.1539-.3437.3808-.651.6654-.9014.4922-.4314 1.1257-.6744 1.7848-.6847h12.2354c.6596.0079 1.2939.2513 1.7848.6847.2928.2463.528.5518.6898.8957.1617.3439.246.7181.2473 1.097Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m43 15.7559-8.5309 5.931c-.2383.2028-.5332.3131-.8369.3131-.3038 0-.5986-.1103-.8369-.3131L27 15.7559c.4963-.4762 1.1351-.7445 1.7998-.7559h12.3734c.6745.0017 1.3248.2708 1.8268.7559Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.1023 19.7284h-2.693c-.238 0-.4664-.0911-.6347-.2531-.1684-.1621-.2629-.3819-.2629-.6111 0-.2292.0945-.449.2629-.6111.1683-.1621.3967-.2531.6347-.2531h2.693c.2381 0 .4664.091.6348.2531.1683.1621.2629.3819.2629.6111 0 .2292-.0946.449-.2629.6111-.1684.162-.3967.2531-.6348.2531Zm-1.3644 2.6358h-4.1024c-.238 0-.4664-.0911-.6347-.2531-.1683-.1621-.2629-.3819-.2629-.6111 0-.2292.0946-.449.2629-.6111.1683-.162.3967-.2531.6347-.2531h4.1024c.2381 0 .4664.0911.6347.2531.1684.1621.2629.3819.2629.6111 0 .2292-.0945.449-.2629.6111-.1683.162-.3966.2531-.6347.2531ZM20.3734 25h-5.4757c-.2381 0-.4664-.0911-.6348-.2531-.1683-.1621-.2629-.3819-.2629-.6111 0-.2292.0946-.449.2629-.6111.1684-.162.3967-.2531.6348-.2531h5.4757c.2381 0 .4664.0911.6348.2531.1683.1621.2629.3819.2629.6111 0 .2292-.0946.449-.2629.6111-.1684.162-.3967.2531-.6348.2531Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
SentEmail2.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "SentEmail2"
};
validateTidalLicense();
export {
  SentEmail2
};
//# sourceMappingURL=SentEmail2.js.map
